import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export const sendPageView = (initialized: boolean) => {
  const location = useLocation();

  useEffect(() => {
      if (initialized) {
        ReactGA.send({ hitType: "pageview", page: location.pathname, title: location.pathname });
      }
  }, [initialized, location]);

};

export const handleClickState = (name: string) => {
  ReactGA.event({
      category: 'State',
      action: 'Click',
      label: name,
  });
};

export const handleClickCounty = (cntyfp: string) => {
  ReactGA.event({
      category: 'State',
      action: 'Click',
      label: cntyfp,
  });
};

export const handleClickYear = (year: string) => {
  ReactGA.event({
      category: 'Year',
      action: 'Click',
      label: year,
  });
};

export const handleDrillUp = () => {
  ReactGA.event({
      category: 'DrillUp',
      action: 'Click',
      label: "DrillUp",
  });
};

export const handleShowEquityIndicator = (show: boolean) => {
  ReactGA.event({
      category: 'Equity Indicator',
      action: 'Click',
      label: show? "Show": "Hide",
  });
};

export const handleEquityIndicator = (indicator: string) => {
  ReactGA.event({
      category: 'Equity Indicator',
      action: 'Click',
      label: indicator,
  });
};

export const handleSummaryIndicator = (indicator: string) => {
  ReactGA.event({
      category: 'Summary Indicator',
      action: 'Click',
      label: indicator,
  });
};

export const handleShowCensusTracts = (show: boolean) => {
  ReactGA.event({
      category: 'Census Tracts',
      action: 'Click',
      label: show? "Show": "Hide",
  });
};

export const handleShowVD = (show: boolean) => {
  ReactGA.event({
      category: 'Voting districts',
      action: 'Click',
      label: show? "Show": "Hide",
  });
};

export const handleShowPolls = (show: boolean) => {
  ReactGA.event({
      category: 'Polls',
      action: 'Click',
      label: show? "Show": "Hide",
  });
};